import React, { useState, useRef } from "react";
import { CERTIFICATE_PROFICIENCY_SYSCODE, CertificateProficiencySyscodeString } from "../../../../constants/certificate_proficiency_syscode.jsx";
import beveatApiResourceOwner from "../../../../api/resource_owner_beveat_api.js";
import { commonConfigs, urls } from "../../../../../config.js";

const ConfirmCertificationModal = ({
  isOpen,
  certifyingItem,
  selectedProficiency,
  handleProficiencyChange,
  handleCancelCertification,
  onConfirmSuccess,
}) => {
  const [isConfirming, setIsConfirming] = useState(false);
  const isApiCalled = useRef(false);

  const handleConfirmCertification = async () => {
    if (isApiCalled.current) return;
    isApiCalled.current = true;

    if (!certifyingItem || !selectedProficiency) {
      alert("Please select a proficiency level before confirming certification.");
      isApiCalled.current = false;
      return;
    }

    setIsConfirming(true);

    try {
      const requestBody = {
        developer_email: certifyingItem.email,
        developer_certificate_id: certifyingItem._original?.developer_certificate_id,
        certificate_proficiency_syscode: parseInt(selectedProficiency)
      };

      const certifyUrl = urls.resourceOwnerUrl + commonConfigs.apiUrls.updateCertificate();
      
      await beveatApiResourceOwner.put(certifyUrl, requestBody, {
        headers: commonConfigs.resourceOwnerApiHeader,
      });

      alert("Student certified successfully!");
      handleCancelCertification(); // This clears the modal state
      if (onConfirmSuccess) {
        onConfirmSuccess();
      }

    } catch (error) {
      console.error("Error certifying student:", error);
      alert("Failed to certify student. Please try again.");
    } finally {
      setIsConfirming(false);
      isApiCalled.current = false;
    }
  };

  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50">
      <div className="bg-white rounded-lg shadow-xl w-full max-w-md mx-4">
        <div className="px-6 py-4 border-b border-gray-200">
          <h2 className="text-xl font-semibold text-gray-800">Confirm Certification</h2>
        </div>
        <div className="px-6 py-6">
          <p className="text-gray-700 mb-4">
            Are you sure you want to certify this record?
          </p>
          {certifyingItem && (
            <div className="mt-4 p-4 bg-gray-50 rounded-lg mb-4">
              <p className="text-sm text-gray-900"><strong>Name:</strong> {certifyingItem.name}</p>
              <p className="text-sm text-gray-900"><strong>Email:</strong> {certifyingItem.email}</p>
            </div>
          )}
          <div className="mb-4">
            <label className="block text-sm font-medium text-gray-700 mb-2">
              Certificate Proficiency Level
            </label>
            <select
              value={selectedProficiency}
              onChange={handleProficiencyChange}
              disabled={isConfirming}
              className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-transparent text-gray-900 disabled:opacity-50"
              required
            >
              <option value="" disabled>
                Select a Proficiency Level
              </option>
              {Object.entries(CERTIFICATE_PROFICIENCY_SYSCODE)
                .filter(([key]) => key !== 'Reserved')
                .map(([key, value]) => (
                  <option key={value} value={value}>
                    {CertificateProficiencySyscodeString[value]}
                  </option>
                ))}
            </select>
          </div>
        </div>
        <div className="px-6 py-4 border-t border-gray-200 flex justify-end space-x-3">
          <button
            onClick={handleCancelCertification}
            disabled={isConfirming}
            className="px-6 py-2 text-gray-700 bg-white border border-gray-300 rounded-md hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-gray-500 transition-colors duration-200 disabled:opacity-50"
          >
            Cancel
          </button>
          <button
            onClick={handleConfirmCertification}
            disabled={!selectedProficiency || isConfirming}
            className={`px-6 py-2 rounded-md focus:outline-none focus:ring-2 transition-colors duration-200 ${
              selectedProficiency && !isConfirming
                ? "bg-blue-600 text-white hover:bg-blue-700 focus:ring-blue-500"
                : "bg-gray-300 text-gray-500 cursor-not-allowed"
            }`}
          >
            {isConfirming ? "Confirming..." : "Confirm"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ConfirmCertificationModal;